export const layersMixin = {
  methods: {
    getActiveLayersNamesList(activeLayers) {
      let activeLayerNames = [];

      if (activeLayers && activeLayers.length > 0) {
        for (const layerLevel of activeLayers) {
          if (layerLevel.hasOwnProperty("layers")) {
            for (const filter of layerLevel.layers) {
              if (filter.layer && filter.layer.layer) {
                let layerName = filter.layer.layer;
                if (
                  layerName !== "" &&
                  !activeLayerNames.find(item => item === layerName)
                ) {
                  activeLayerNames.push(layerName);
                }
              }
            }
          }
        }
      }
      return activeLayerNames;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/layersMixin.js